export default __webpack_public_path__ + "static/media/about-thumb-8-challenge.99956e9b.png";